import { IOwnedAlbum} from '../data_models/ialbum';
import { AGTranslator } from './ag_translator';
import { IPhoto } from '../data_models/iphoto';


/**
 * Responsible to translate all the User Assets Response Models to the Common model, which clients can understand. 
 * @export
 * @class UATranslator
 * @implements {ITranslator}
 */
export class GoogleIngTranslator {
  /* istanbul ignore next */
  static getInstance(): GoogleIngTranslator {
    if (!GoogleIngTranslator.instance) {
      GoogleIngTranslator.instance = new GoogleIngTranslator();
    }
    return GoogleIngTranslator.instance;
  }
  private static instance: GoogleIngTranslator;

  /* istanbul ignore next */
  translateOwnedAlbum(entity: any): IOwnedAlbum {
    
    const album: IOwnedAlbum = {
      albumId: entity.id,
      url: entity.coverPhotoBaseUrl+"=h200",
      source: "google",
      accountId: 0,
      updateDate: undefined,
      createDate: undefined,      
      dataCenter: "",
      systemTags: [],
      userTags: [{key: "caption", value: entity.title}],
      photoCount: entity.mediaItemsCount,
    };
    //In all albums api , we wont get firstPhoto information
    
      album.firstAssetId = {
        assetId: entity.coverPhotoMediaItemId,
        ownerId: "",
        assetSource: "google",
        thumbnailEncryption: entity.coverPhotoBaseUrl+"=h200"
      };
    
    return album;
  }
  /* istanbul ignore next */
  translateGooglePhoto(entity: any,accountId:string): IPhoto {    
    let imageDimInfo = entity.mediaFile;
    if(!imageDimInfo){
        imageDimInfo =  {width: "200",height:"200"}
    }

    const photo: any = {
        id: entity.id,
        accountId: accountId,
        documentId: entity.documentId,
        dataCenter: "AUS",
        name: imageDimInfo.filename,
        size: 0,
        assetId: entity.id,
        url: imageDimInfo.baseUrl,
        createDate: entity.createTime,
        updateDate: entity.createTime,
        dateTaken: entity.createTime,
        lrHeight: imageDimInfo.mediaFileMetadata.height,
        lrWidth: imageDimInfo.mediaFileMetadata.width,
        landscape: imageDimInfo.mediaFileMetadata.width >= imageDimInfo.mediaFileMetadata.height ? true :false,
        assetSource: "google",
        reportingMediaSource: "google",
        mimeType: imageDimInfo.mimeType
    }     
    return photo;
  }
  /* istanbul ignore next */
  translateGoogleClusterPhoto = function (entity: any, accountId: string):IPhoto {  
    var pasConvertedImage = GoogleIngTranslator.getInstance().translateGooglePhoto(entity,accountId);
    var photo = AGTranslator.getInstance().translatePhoto(pasConvertedImage);
    return photo;
  };  
  /* istanbul ignore next */
  translateAlbumPhotos(response: any): any {
    let alumResponse = {albumPhotos: {entities: response}};
    let albumPhotos = AGTranslator.getInstance().translateOwnedAlbumPhotos(true,alumResponse)
    return albumPhotos;
  }
}